import { RefObject } from "react";
import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import styles from "./AnonymousBackInStockModal.scss";
import classNames from "classnames";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { fireDifferentEmailClickAnalytics } from "../../analytics/anonymousBackInStock";

type Props = {
  recognisedHeadingRef: RefObject<HTMLHeadingElement>;
  selectedVariantId?: number;
  onSignIn: () => void;
  onUseDifferentEmail: () => void;
};

const AnonymousBackInStockRecognisedCustomer = ({
  recognisedHeadingRef,
  selectedVariantId,
  onSignIn,
  onUseDifferentEmail,
}: Props): JSX.Element => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  const handleUseDifferentEmail = () => {
    fireDifferentEmailClickAnalytics(selectedVariantId);
    onUseDifferentEmail();
  };

  return (
    <div className={styles.recognisedCustomer}>
      <h2 id="modalTitle" className={styles.title}>
        {getTranslation("anonymous_back_in_stock_modal_heading")}
      </h2>
      <div className={styles.recognisedCustomerContent}>
        <h3 ref={recognisedHeadingRef} tabIndex={-1} className={styles.text}>
          {getTranslation(
            "anonymous_back_in_stock_recognised_customer_modal_heading",
          )}
        </h3>
        <p className={styles.text}>
          {getTranslation(
            "anonymous_back_in_stock_recognised_customer_modal_body",
          )}
        </p>
        <Button
          handleClick={onSignIn}
          type={BUTTON_TYPES.primary}
          additionalClasses={styles.button}
        >
          {getTranslation(
            "anonymous_back_in_stock_recognised_customer_modal_primary_cta",
          )}
        </Button>
        <Button
          handleClick={handleUseDifferentEmail}
          type={BUTTON_TYPES.secondary}
          additionalClasses={classNames(styles.button, styles.buttonSecondary)}
        >
          {getTranslation(
            "anonymous_back_in_stock_recognised_customer_modal_secondary_cta",
          )}
        </Button>
      </div>
    </div>
  );
};

export default AnonymousBackInStockRecognisedCustomer;
